import { chat, kinoParticipants } from "../../libs/roomnew";
import { debounce } from "../base/video-quality/actions";
const chatList = $('#all-chats-list-container');
const GROUP_AVATAR = `<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2154_492)">
<path d="M18 35.4375C27.6305 35.4375 35.4375 27.6305 35.4375 18C35.4375 8.36953 27.6305 0.5625 18 0.5625C8.36953 0.5625 0.5625 8.36953 0.5625 18C0.5625 27.6305 8.36953 35.4375 18 35.4375Z" fill="#CCD7FA"/>
<path d="M28.3554 17.5537C29.9426 17.5537 31.2293 16.267 31.2293 14.6798C31.2293 13.0926 29.9426 11.806 28.3554 11.806C26.7682 11.806 25.4816 13.0926 25.4816 14.6798C25.4816 16.267 26.7682 17.5537 28.3554 17.5537Z" fill="#375F94"/>
<path d="M8.20894 17.5537C9.79612 17.5537 11.0828 16.267 11.0828 14.6798C11.0828 13.0926 9.79612 11.806 8.20894 11.806C6.62175 11.806 5.33508 13.0926 5.33508 14.6798C5.33508 16.267 6.62175 17.5537 8.20894 17.5537Z" fill="#375F94"/>
<path d="M28.3555 19.507C27.0588 19.507 25.8738 19.9816 24.9625 20.7657C25.9963 21.8988 26.7117 23.252 27.0642 24.7159H33.5643C33.5643 21.8392 31.2322 19.507 28.3555 19.507ZM18.2821 19.7666C14.3715 19.7666 11.2013 22.9368 11.2013 26.8474H25.3629C25.3629 22.9368 22.1927 19.7666 18.2821 19.7666ZM8.20885 19.507C5.33207 19.507 3 21.8391 3 24.7159H9.50013C9.85257 23.252 10.568 21.8988 11.6018 20.7657C10.6905 19.9817 9.50547 19.507 8.20885 19.507Z" fill="#375F94"/>
<path d="M18.2821 17.8133C20.4397 17.8133 22.1888 16.0642 22.1888 13.9066C22.1888 11.7491 20.4397 10 18.2821 10C16.1246 10 14.3755 11.7491 14.3755 13.9066C14.3755 16.0642 16.1246 17.8133 18.2821 17.8133Z" fill="#375F94"/>
</g>
<defs>
<clipPath id="clip0_2154_492">
<rect width="36" height="36" fill="white"/>
</clipPath>
</defs>
</svg>`

const PERSON_AVATAR = `<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2154_528)">
<path d="M18 35.4375C27.6305 35.4375 35.4375 27.6305 35.4375 18C35.4375 8.36953 27.6305 0.5625 18 0.5625C8.36953 0.5625 0.5625 8.36953 0.5625 18C0.5625 27.6305 8.36953 35.4375 18 35.4375Z" fill="#CCD7FA"/>
<path d="M31.9933 28.3922C30.367 26.2149 28.2553 24.447 25.826 23.2289C23.3967 22.0107 20.7167 21.376 17.9992 21.3752C15.2816 21.3743 12.6012 22.0073 10.1711 23.2238C7.74103 24.4404 5.62818 26.207 4.00049 28.3832C5.61986 30.5705 7.72922 32.3479 10.1594 33.573C12.5897 34.798 15.2731 35.4366 17.9946 35.4374C20.7162 35.4383 23.4 34.8015 25.831 33.578C28.262 32.3545 30.3725 30.5785 31.9933 28.3922Z" fill="#375F94"/>
<path d="M18 19.125C21.7279 19.125 24.75 16.1029 24.75 12.375C24.75 8.64708 21.7279 5.625 18 5.625C14.2721 5.625 11.25 8.64708 11.25 12.375C11.25 16.1029 14.2721 19.125 18 19.125Z" fill="#375F94"/>
</g>
<defs>
<clipPath id="clip0_2154_528">
<rect width="36" height="36" fill="white"/>
</clipPath>
</defs>
</svg>`
import tippy from 'tippy.js';
export const renderChatsList=()=>{
    const filter = $("#chats-search-input").val();
    let chats = getFormattedChats();
    if (filter) {
        chats = chats.filter((fchat) => {
            return fchat.name.toLowerCase().search(filter.toLowerCase()) > -1;
        });
    }
    chatList.empty();
    chats.forEach((renderchat) => {
        renderChatItem(renderchat);
    });
}
export const debounceSearchChats = debounce(renderChatsList, 200);

export const renderChatItem=(renderchat)=>{

    const chatLogo = $('<div>', {
        class: 'list-chat-logo',
        html: [renderchat?.group && (renderchat.members?.length > 2 || renderchat.name === 'Public Chat') ? GROUP_AVATAR : PERSON_AVATAR,
        `<span class="user-status-badge ${renderchat.isOnline ? 'online' : ''}"></span>`
        ],
    });
    const unreadBadge=$('<span/>',{
        class:'unread-badge',
        html: renderchat.unread > 0 ? renderchat.unread : '',
    })
    const chatName = $('<div>', {
        class: 'list-chat-name',
        html: [`<span>${renderchat.name}</span>`,unreadBadge]
    });

    const lastMessage = $('<div>', {
        class: 'list-chat-last-message',
        html: `<span class="chat-last-message-cont">${renderchat.lastMessage}</span><span class="last-message-time"></span>`,
    });

    const chatItemContent = $('<div>', {
        class: 'list-chat-item-content',
        html: [chatName, lastMessage]
    });
    tippy(chatName[0], {
        content: renderchat.name,
        allowHTML: false,
        placement: 'top',
        theme: 'light',
        arrow: false,
        offset: [0, 0],
        duration: 0,
        delay: [1000, 0],
        animation: 'shift-away',
        interactive: true,
    })
    const chatItem = $('<div>', {
        class: `list-chat-item ${isChatSelected(renderchat) ? 'active' : ''}`,
        groupid: renderchat.group,
        participant: renderchat.pId,
        html:[chatLogo, chatItemContent]
    }).on('click', function(){
        chat.setChatselected(renderchat);
        if(renderchat.group){
            setSelectedChatActive(renderchat.group);
        }else{
            chatList.find('.list-chat-item').removeClass('active');
            $(this).addClass('active');
            renderChatHeader(createTemporaryChat([
                {guest_id: renderchat.pId, displayName: renderchat.name, user_id: 0},
                {guest_id: chat.myUniqueId, displayName: chat.myDisplayName, user_id: USER_ID}
            ]));
        }
    });

    chatList.append(chatItem);
    if(isChatSelected(renderchat)){
        renderChatHeader(renderchat);
    }
}
const isChatSelected = (c)=>{
    return chat.selectedChatId === c?.group
}

export const setSelectedChatActive=(chatId)=>{
    chatList.find('.list-chat-item').removeClass('active');
    $(`.list-chat-item[groupid="${chatId}"]`).addClass('active');
    const selectedChat = findChatById(chatId);
    renderChatHeader(selectedChat);
}

const createTemporaryChat=(participants)=>{
    const tempChat = {
          pId: null,
          group: null,
          members: participants,
          name: participants
          .filter(
            (participant) =>
              participant.guest_id != chat.myUniqueId &&
              (USER_ID == 0 || participant.user_id != USER_ID)
          )
          .map((participant) => participant.displayName)
          .join(", "),
          isChat: false,
          lastMessage: 'Tap to chat',
          isOnline: false,
    }
    chat.selectedParticipantsToMessage=participants.map((p)=>p.guest_id);
    return tempChat
}

const getFormattedChats=()=>{
    const participants = chat.getChatsListArray();
    chat.groupUniqueParticipants().forEach((el) => {
        participants.push({
          pId: el,
          group: null,
          members: [],
          name: chat.getParticipantDisplayName(el),
          isChat: false,
          lastMessage: 'Tap to chat',
          isOnline: chat.isParticipantOnline(el),
          unread: 0,
        });
    });
    return participants;
}

export const renderChatHeader = (currentchat=null)=>{
    const selectedChat = currentchat || getSelectedChat();
    if(selectedChat){
        const chatHeader = $('#current-chat-header');
        const chatName = selectedChat?.name || 'Public Chat';
        const chatLogo = selectedChat?.group && (selectedChat.members?.length > 2 || selectedChat.name === 'Public Chat') ? GROUP_AVATAR : PERSON_AVATAR;
        const pcount = selectedChat.members?.length > 0 ? selectedChat.members?.length + ' participants':kinoParticipants.getParticipants().length + ' online';
        chatHeader.find('.header-chat-icon').html(chatLogo);
        chatHeader.find('.chat-name').html(chatName);
        chatHeader.find('.chat-participants').html(pcount);

    }
}

const getSelectedChat=()=>{
    const chats = chat.getChatsListArray();
    return chats.find((c) => c.group === chat.selectedChatId);
}

export const findChatById=(chatId)=>{
    const chats = chat.getChatsListArray();
    return chats.find((c) => c.group === chatId);
}

export const updateChatBadge=(group_id,unread)=>{
    const chatItem = chatList.find(`.list-chat-item[groupid="${group_id}"]`);
    const lastMessage = chat.getChatLastMessage(group_id)
    chatItem.find('.unread-badge').html(unread > 0 ? unread : '');
    chatItem.find('.chat-last-message-cont').html(lastMessage);
}
